module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/00_Cover"
    }
  }, [_vm._v("The Lost Princess of Oz")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/title"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/05_Chapter_1"
    }
  }, [_vm._v(" A Terrible Loss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/06_Chapter_2"
    }
  }, [_vm._v(" Troubles of Glinda the Good")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/07_Chapter_3"
    }
  }, [_vm._v(" Robbery of Cayke the Cookie Cook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/08_Chapter_4"
    }
  }, [_vm._v(" Among the Winkies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/09_Chapter_5"
    }
  }, [_vm._v(" Ozma’s Friends Are Perplexed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/10_Chapter_6"
    }
  }, [_vm._v(" The Search Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/11_Chapter_7"
    }
  }, [_vm._v(" The Merry-Go-Round Mountains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/12_Chapter_8"
    }
  }, [_vm._v(" The Mysterious City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/13_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The High Coco-Lorum of Thi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/14_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Toto Loses Something")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/15_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Button-Bright Loses Himself")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/16_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Czarover of Herku")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/17_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Truth Pond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/18_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Unhappy Ferryman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/19_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Big Lavender Bear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/20_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Little Pink Bear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/21_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Meeting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/22_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Conference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/23_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ugu the Shoemaker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/24_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" More Surprises")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/25_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Magic Against Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/26_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" In the Wicker Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/27_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Defiance of Ugu the Shoemaker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/28_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Little Pink Bear Speaks Truly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/29_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ozma of Oz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/30_Chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Dorothy Forgives")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/00_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tin Woodman of Oz")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/02_Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/08_Chapter_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Woot the Wanderer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/09_Chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Heart of the Tin Woodman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/10_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Roundabout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/11_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Loons of Loonville")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/12_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mrs. Yoop, the Giantess")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/13_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Magic of a Yookoohoo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/14_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Lace Apron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/15_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Menace of the Forest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/16_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Quarrelsome Dragons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/17_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Tommy Kwikstep")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/18_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Jinjur’s Ranch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/19_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ozma and Dorothy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/20_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Restoration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/21_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Green Monkey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/22_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Man of Tin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/23_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Captain Fyter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/24_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Workshop of Ku-Klip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/25_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Tin Woodman Talks to Himself")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/26_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Invisible Country")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/27_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Over Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/28_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Polychrome’s Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/29_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Nimmie Amee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/30_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Through the Tunnel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/31_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Curtain Falls")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/00_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Magic Of Oz")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/08_Chapter_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mount Munch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/09_Chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Hawk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/10_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Two Bad Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/11_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Conspirators")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/12_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" A Happy Corner of Oz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/13_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ozma’s Birthday Presents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/14_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Forest of Gugu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/15_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Li-Mon-Eags Make Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/16_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Isle of the Magic Flower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/17_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Stuck Fast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/18_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Beasts of the Forest of Gugu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/19_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Kiki Uses His Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/20_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Loss of the Black Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/21_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Wizard Learns the Magic Word")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/22_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Lonesome Duck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/23_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Glass Cat Finds the Black Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/24_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" A Remarkable Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/25_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Magic of the Wizard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/26_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Dorothy and the Bumble Bees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/27_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Monkeys Have Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/28_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The College of Athletic Arts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/29_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ozma’s Birthday Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/30_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Fountain of Oblivion")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/00_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glinda of Oz")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/01_Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/03_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Call to Duty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/04_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ozma and Dorothy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/05_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Mist Maidens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/06_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Magic Tent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/07_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Magic Stairway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/08_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Flathead Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/09_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Magic Isle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/10_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Queen Coo-ee-oh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/11_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Lady Aurex")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/12_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Under Water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/13_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Conquest of the Skeezers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/14_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Diamond Swan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/15_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Alarm Bell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/16_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Ozma’s Counsellors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/17_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Great Sorceress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/18_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Enchanted Fishes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/19_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Under the Great Dome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/20_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Cleverness of Ervic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/21_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Red Reera the Yookoohoo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/22_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" A Puzzling Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/23_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Three Adepts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/24_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Sunken Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/25_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Magic Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book4/xhtml/26_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Glinda’s Triumph")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27d5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 60
// module chunks = 0